(function () {
  function cleanEmptyFilterParamsInUrl() {
    try {
      var url = new URL(window.location.href);
      var changed = false;
      url.searchParams.forEach(function (value, key) {
        if (value === '') {
          url.searchParams.delete(key);
          changed = true;
        }
      });
      if (changed) {
        var next = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
        window.history.replaceState(window.history.state, '', next);
      }
    } catch (error) {
      /* ignore */
    }
  }

  cleanEmptyFilterParamsInUrl();

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function findDrawer(section) {
    if (!section) return null;
    var drawer = section.querySelector('[data-ci-filters-drawer]');
    if (drawer) return drawer;
    var sectionId = section.dataset.ciBrandSectionId;
    if (!sectionId) return null;
    return document.querySelector(
      '[data-ci-filters-drawer][data-ci-filters-section="' + sectionId + '"]'
    );
  }

  function parseUnpublishedBrandHandles(section) {
    var raw = (section && section.dataset.ciUnpublishedBrandHandles) || '';
    if (!raw) return [];
    return raw
      .split(',')
      .map(function (handle) {
        return handle.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function parsePublishedBrandHandles(section) {
    var raw = (section && section.dataset.ciPublishedBrandHandles) || '';
    if (!raw) return [];
    return raw
      .split(',')
      .map(function (handle) {
        return handle.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function productShouldHideFromCatalog(item, unpublishedHandles, publishedHandles) {
    var hiddenBrands = (item.getAttribute('data-brand-hidden-collections') || '').trim();
    if (hiddenBrands) return true;

    var brands = (item.getAttribute('data-brand-collections') || '')
      .split(',')
      .map(function (handle) {
        return handle.trim().toLowerCase();
      })
      .filter(Boolean);

    if (brands.length && unpublishedHandles.length) {
      var hasUnpublishedBrand = brands.some(function (handle) {
        return unpublishedHandles.indexOf(handle) !== -1;
      });
      if (hasUnpublishedBrand) return true;
    }

    if (!brands.length && publishedHandles.length) {
      var vendorHandle = (item.getAttribute('data-product-vendor-handle') || '').trim().toLowerCase();
      if (!vendorHandle || publishedHandles.indexOf(vendorHandle) === -1) return true;
    }

    return false;
  }

  function CiBrandCollectionFilters(section) {
    this.section = section;
    this.sectionId = section.dataset.ciBrandSectionId;
    this.unpublishedBrandHandles = parseUnpublishedBrandHandles(section);
    this.publishedBrandHandles = parsePublishedBrandHandles(section);
    this.drawer = findDrawer(section);

    if (this.drawer && this.drawer.parentNode !== document.body) {
      document.body.appendChild(this.drawer);
    }

    this.panel = this.drawer;
    this.form = this.panel ? this.panel.querySelector('#FacetFiltersForm') : null;
    this.gridContainer = section.querySelector('#ProductGridContainer');
    this.openButtons = section.querySelectorAll('[data-ci-filters-open]');
    this.closeButtons = this.panel
      ? this.panel.querySelectorAll('[data-ci-filters-close]')
      : [];
    this.clearButton = this.panel ? this.panel.querySelector('.ci-cbg-filters__clear') : null;
    this.sortSelect = section.querySelector('[data-ci-brand-sort]');
    this.searchParamsPrev = '';
    this.isOpen = false;
    this.metaStorageKey = 'ci-cbg-meta-' + this.sectionId;
    this.brandStorageKey = 'ci-cbg-brands-' + this.sectionId;
    this.hasBrandFilter = false;
    this.isCatalog = section.dataset.ciCollectionScope === 'catalog';
    this.brandFetchId = 0;
    var self = this;
    this.scheduleBrandFetch = debounce(function () {
      self.fetchBrandProducts();
    }, 400);

    section._ciFilters = this;

    this.bind();
    this.filterUnpublishedCatalogProducts();
    this.restoreMetaFilters();
    this.restoreBrandFilters();
    if (this.isCatalog && this.getBrandSelection().length > 0) {
      this.fetchBrandProducts();
    } else {
      this.applyClientFilters();
    }
    this.updateBadge();
  }

  CiBrandCollectionFilters.prototype.filterUnpublishedCatalogProducts = function () {
    if (!this.isCatalog) return;

    var removed = 0;
    this.getItems().forEach(function (item) {
      if (!productShouldHideFromCatalog(item, this.unpublishedBrandHandles, this.publishedBrandHandles)) return;
      item.setAttribute('hidden', '');
      item.setAttribute('data-ci-unpublished-hidden', 'true');
      removed += 1;
    }, this);

    if (removed > 0) {
      this.syncVisibility();
    }

    if (this.isCatalog) {
      this.recountCatalogVisibleTotal();
    }
  };

  CiBrandCollectionFilters.prototype.syncCatalogBaseCount = function () {
    if (!this.isCatalog) return;

    var visible = 0;
    this.getItems().forEach(function (item) {
      if (item.getAttribute('data-ci-unpublished-hidden') !== 'true') visible += 1;
    });

    var countValueEl = this.section.querySelector('[data-brand-count-value]');
    var countEl = this.section.querySelector('[data-brand-count]');
    if (!countValueEl) return;

    countValueEl.textContent = String(visible);
    countValueEl.dataset.baseCount = String(visible);
    if (countEl) countEl.classList.remove('is-filtered');
  };

  CiBrandCollectionFilters.prototype.recountCatalogVisibleTotal = function () {
    if (!this.isCatalog) return;

    var self = this;
    var root = this.gridContainer && this.gridContainer.querySelector('[data-ci-load-more-root]');
    if (!root) {
      this.syncCatalogBaseCount();
      return;
    }

    var totalPages = parseInt(root.dataset.ciLoadMorePages || '1', 10) || 1;
    var path = window.location.pathname;
    var pageOneVisible = 0;

    this.getItems().forEach(function (item) {
      if (item.getAttribute('data-ci-unpublished-hidden') !== 'true') pageOneVisible += 1;
    });

    if (totalPages <= 1) {
      var countValueEl = this.section.querySelector('[data-brand-count-value]');
      if (countValueEl) {
        countValueEl.textContent = String(pageOneVisible);
        countValueEl.dataset.baseCount = String(pageOneVisible);
      }
      return;
    }

    var pageFetches = [];
    for (var page = 2; page <= totalPages; page += 1) {
      pageFetches.push(this.fetchCollectionSectionDoc(path, page));
    }

    Promise.all(pageFetches)
      .then(function (results) {
        var total = pageOneVisible;
        results.forEach(function (result) {
          if (result && result.items) total += result.items.length;
        });
        var countEl = self.section.querySelector('[data-brand-count-value]');
        if (countEl) {
          countEl.textContent = String(total);
          countEl.dataset.baseCount = String(total);
        }
      })
      .catch(function () {
        self.syncCatalogBaseCount();
      });
  };

  CiBrandCollectionFilters.prototype.queryPanel = function (selector) {
    return this.panel ? this.panel.querySelector(selector) : null;
  };

  CiBrandCollectionFilters.prototype.queryPanelAll = function (selector) {
    return this.panel ? this.panel.querySelectorAll(selector) : [];
  };

  CiBrandCollectionFilters.prototype.bind = function () {
    var self = this;

    this.openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.open();
      });
    });

    this.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (btn.tagName === 'A') return;
        event.preventDefault();
        self.close();
      });
    });

    if (this.drawer) {
      this.drawer.addEventListener('click', function (event) {
        if (!self.isOpen) return;
        var panel = self.drawer.querySelector('.ci-cbg-filters__panel');
        if (panel && panel.contains(event.target)) return;
        self.close();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.isOpen) self.close();
    });

    this.rebindForm();
    this.bindMetaFilters();
    this.bindBrandFilters();

    if (this.clearButton) {
      this.clearButton.addEventListener('click', function () {
        self.clearClientFilters();
      });
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', function () {
        if (self.isCatalog && self.getBrandSelection().length > 0) {
          self.fetchBrandProducts();
          return;
        }
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', self.sortSelect.value);
        self.renderPage(params.toString());
      });
    }

    window.addEventListener('popstate', function (event) {
      var searchParams = event.state && event.state.searchParams ? event.state.searchParams : window.location.search.slice(1);
      self.renderPage(searchParams, false);
    });
  };

  CiBrandCollectionFilters.prototype.open = function () {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ci-cbg-filters-locked');
    this.isOpen = true;
  };

  CiBrandCollectionFilters.prototype.close = function () {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ci-cbg-filters-locked');
    this.isOpen = false;
  };

  CiBrandCollectionFilters.prototype.getItems = function () {
    return this.section.querySelectorAll('[data-brand-product]');
  };

  CiBrandCollectionFilters.prototype.getMetaSelection = function () {
    var groups = {};
    this.queryPanelAll('[data-ci-meta-filter]:checked').forEach(function (input) {
      var attr = input.getAttribute('data-ci-meta-attr');
      var value = input.getAttribute('data-ci-meta-value');
      if (!attr || !value) return;
      if (!groups[attr]) groups[attr] = [];
      groups[attr].push(value);
    });
    return groups;
  };

  CiBrandCollectionFilters.prototype.saveMetaFilters = function () {
    try {
      sessionStorage.setItem(this.metaStorageKey, JSON.stringify(this.getMetaSelection()));
    } catch (error) {
      /* ignore */
    }
  };

  CiBrandCollectionFilters.prototype.restoreMetaFilters = function () {
    var stored = null;
    try {
      stored = JSON.parse(sessionStorage.getItem(this.metaStorageKey) || '{}');
    } catch (error) {
      stored = {};
    }
    if (!stored || typeof stored !== 'object') return;

    this.queryPanelAll('[data-ci-meta-filter]').forEach(function (input) {
      var attr = input.getAttribute('data-ci-meta-attr');
      var value = input.getAttribute('data-ci-meta-value');
      if (!attr || !value) return;
      input.checked = stored[attr] && stored[attr].indexOf(value) !== -1;
    });
  };

  CiBrandCollectionFilters.prototype.getBrandSelection = function () {
    var selected = [];
    this.queryPanelAll('[data-ci-brand-filter]:checked').forEach(function (input) {
      var value = (input.value || '').trim().toLowerCase();
      if (value) selected.push(value);
    });
    return selected;
  };

  CiBrandCollectionFilters.prototype.saveBrandFilters = function () {
    if (!this.hasBrandFilter) return;
    try {
      sessionStorage.setItem(this.brandStorageKey, JSON.stringify(this.getBrandSelection()));
    } catch (error) {
      /* ignore */
    }
  };

  CiBrandCollectionFilters.prototype.restoreBrandFilters = function () {
    if (!this.hasBrandFilter) return;
    var stored = [];
    try {
      stored = JSON.parse(sessionStorage.getItem(this.brandStorageKey) || '[]');
    } catch (error) {
      stored = [];
    }
    if (!Array.isArray(stored)) stored = [];

    this.queryPanelAll('[data-ci-brand-filter]').forEach(function (input) {
      var value = (input.value || '').trim().toLowerCase();
      input.checked = stored.indexOf(value) !== -1;
    });
  };

  CiBrandCollectionFilters.prototype.clearClientFilters = function () {
    this.queryPanelAll('[data-ci-meta-filter]').forEach(function (input) {
      input.checked = false;
    });
    this.queryPanelAll('[data-ci-brand-filter]').forEach(function (input) {
      input.checked = false;
    });
    var brandSearch = this.queryPanel('[data-ci-brand-filter-search]');
    if (brandSearch) {
      brandSearch.value = '';
      this.filterBrandList('');
    }
    try {
      sessionStorage.removeItem(this.metaStorageKey);
      sessionStorage.removeItem(this.brandStorageKey);
    } catch (error) {
      /* ignore */
    }
    if (this.isCatalog) {
      this.applyMetaFiltersOnly();
      this.updateBadge();
      this.fetchBrandProducts();
      return;
    }
    this.applyClientFilters();
    this.updateBadge();
  };

  CiBrandCollectionFilters.prototype.getSortParam = function () {
    return this.sortSelect ? this.sortSelect.value : '';
  };

  CiBrandCollectionFilters.prototype.buildSectionFetchUrl = function (path, page) {
    var url = new URL(path, window.location.origin);
    url.searchParams.set('section_id', this.sectionId);
    var sortBy = this.getSortParam();
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    if (page && page > 1) url.searchParams.set('page', String(page));
    return url.toString();
  };

  CiBrandCollectionFilters.prototype.findProductGridContainer = function (doc) {
    if (!doc) return null;
    return (
      doc.getElementById('ProductGridContainer') ||
      (doc.querySelector && doc.querySelector('#ProductGridContainer'))
    );
  };

  CiBrandCollectionFilters.prototype.fetchCollectionSectionDoc = function (path, page) {
    var self = this;
    return fetch(this.buildSectionFetchUrl(path, page), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Section fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = self.findProductGridContainer(doc);
        var root = grid ? grid.querySelector('[data-ci-load-more-root]') : null;
        var totalPages = 1;
        if (root) {
          totalPages =
            parseInt(root.getAttribute('data-ci-load-more-pages') || root.dataset.ciLoadMorePages || '1', 10) ||
            1;
        }
        return {
          doc: doc,
          grid: grid,
          items: Array.from(doc.querySelectorAll('[data-ci-load-more-item]')),
          totalPages: totalPages,
        };
      });
  };

  CiBrandCollectionFilters.prototype.fetchAllPagesForBrand = function (handle) {
    var self = this;
    var path = '/collections/' + encodeURIComponent(handle);

    return this.fetchCollectionSectionDoc(path, 1).then(function (first) {
      var allItems = first.items.slice();
      if (first.totalPages <= 1) return allItems;

      var pageFetches = [];
      for (var page = 2; page <= first.totalPages; page += 1) {
        pageFetches.push(
          self.fetchCollectionSectionDoc(path, page).then(function (result) {
            return result.items;
          })
        );
      }

      return Promise.all(pageFetches).then(function (pages) {
        pages.forEach(function (pageItems) {
          allItems = allItems.concat(pageItems);
        });
        return allItems;
      });
    });
  };

  CiBrandCollectionFilters.prototype.afterGridReady = function (callback) {
    var self = this;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        callback.call(self);
      });
    });
  };

  CiBrandCollectionFilters.prototype.revealAllGridItems = function () {
    this.getItems().forEach(function (item) {
      item.classList.remove('is-ci-load-more-hidden');
      item.removeAttribute('hidden');
      item.removeAttribute('data-ci-brand-hidden');
      item.removeAttribute('data-ci-meta-hidden');
    });

    var root = this.gridContainer && this.gridContainer.querySelector('[data-ci-load-more-root]');
    if (root && root._ciLoadMore) {
      if (typeof root._ciLoadMore.showAll === 'function') {
        root._ciLoadMore.showAll();
      }
      if (typeof root._ciLoadMore.setDisabled === 'function') {
        root._ciLoadMore.setDisabled(true);
      }
    }

    var pagination = this.gridContainer && this.gridContainer.querySelector('[data-ci-load-more-pagination]');
    if (pagination) pagination.hidden = true;

    var endMessage = this.gridContainer && this.gridContainer.querySelector('[data-ci-load-more-end]');
    if (endMessage) endMessage.hidden = false;
  };

  CiBrandCollectionFilters.prototype.applyMetaFiltersOnly = function () {
    var groups = this.getMetaSelection();
    var groupKeys = Object.keys(groups);
    var hasMeta = groupKeys.length > 0;
    var items = this.getItems();

    items.forEach(function (item) {
      if (!hasMeta) {
        item.removeAttribute('data-ci-meta-hidden');
        return;
      }

      var visible = true;
      groupKeys.forEach(function (attr) {
        var selected = groups[attr];
        var productVals = (item.getAttribute('data-' + attr) || '').split('|').filter(Boolean);
        var match = selected.some(function (val) {
          return productVals.indexOf(val) !== -1;
        });
        if (!match) visible = false;
      });

      if (visible) item.removeAttribute('data-ci-meta-hidden');
      else item.setAttribute('data-ci-meta-hidden', 'true');
    });

    this.syncVisibility();
    this.saveMetaFilters();
  };

  CiBrandCollectionFilters.prototype.applyClientFilters = function () {
    if (this.isCatalog && this.hasBrandFilter && this.getBrandSelection().length > 0) {
      this.applyMetaFiltersOnly();
      this.saveBrandFilters();
      this.updateBadge();
      return;
    }

    var groups = this.getMetaSelection();
    var groupKeys = Object.keys(groups);
    var brandSelection = this.getBrandSelection();
    var hasMeta = groupKeys.length > 0;
    var hasBrand = brandSelection.length > 0;
    var items = this.getItems();

    items.forEach(function (item) {
      var visible = true;

      if (hasMeta) {
        groupKeys.forEach(function (attr) {
          var selected = groups[attr];
          var productVals = (item.getAttribute('data-' + attr) || '').split('|').filter(Boolean);
          var match = selected.some(function (val) {
            return productVals.indexOf(val) !== -1;
          });
          if (!match) visible = false;
        });
      }

      if (visible && hasBrand) {
        var productBrands = (item.getAttribute('data-brand-collections') || '')
          .split(',')
          .map(function (handle) {
            return handle.trim().toLowerCase();
          })
          .filter(Boolean);
        var brandMatch = brandSelection.some(function (handle) {
          return productBrands.indexOf(handle) !== -1;
        });
        if (!brandMatch) visible = false;
      }

      if (visible) {
        item.removeAttribute('data-ci-meta-hidden');
        item.removeAttribute('data-ci-brand-hidden');
      } else {
        item.setAttribute('data-ci-meta-hidden', 'true');
        item.setAttribute('data-ci-brand-hidden', 'true');
      }
    });

    this.syncVisibility();
    this.saveMetaFilters();
    this.saveBrandFilters();
    this.updateBadge();
  };

  CiBrandCollectionFilters.prototype.dispatchGridUpdated = function () {
    this.filterUnpublishedCatalogProducts();
    document.dispatchEvent(
      new CustomEvent('ci:collection-grid:updated', {
        detail: { section: this.section },
      })
    );
    document.dispatchEvent(
      new CustomEvent('ci:product-grid:updated', {
        detail: { root: this.gridContainer },
      })
    );
  };

  CiBrandCollectionFilters.prototype.updateCountFromDoc = function (doc, fallbackCount) {
    var newCount = doc.querySelector('[data-brand-count]');
    var countTarget = this.section.querySelector('[data-brand-count]');
    if (!countTarget) return;

    if (newCount) {
      countTarget.innerHTML = newCount.innerHTML;
    }

    var countValueEl = countTarget.querySelector('[data-brand-count-value]');
    if (!countValueEl) return;

    if (typeof fallbackCount === 'number') {
      countValueEl.textContent = String(fallbackCount);
    }

    countValueEl.dataset.baseCount = countValueEl.textContent;
    countTarget.classList.add('is-filtered');
  };

  CiBrandCollectionFilters.prototype.configureLoadMoreRoot = function (options) {
    options = options || {};
    if (!this.gridContainer) return;

    var root = this.gridContainer.querySelector('[data-ci-load-more-root]');
    if (!root) return;

    if (options.fetchPath) {
      root.setAttribute('data-ci-load-more-fetch-path', options.fetchPath);
    } else {
      root.removeAttribute('data-ci-load-more-fetch-path');
    }

    if (options.totalCount != null) {
      root.setAttribute('data-ci-search-results-count', String(options.totalCount));
    }

    if (options.singlePage) {
      root.dataset.ciLoadMorePages = '1';
      root.dataset.ciLoadMorePage = '1';
    }
  };

  CiBrandCollectionFilters.prototype.applyGridFromDocument = function (doc, options) {
    var self = this;
    options = options || {};
    var newGrid = this.findProductGridContainer(doc);
    if (!newGrid || !this.gridContainer) return;

    this.gridContainer.innerHTML = newGrid.innerHTML;
    this.configureLoadMoreRoot(options);
    this.updateCountFromDoc(doc, options.totalCount);
    this.dispatchGridUpdated();

    if (options.revealAll) {
      this.afterGridReady(function () {
        self.revealAllGridItems();
        self.applyMetaFiltersOnly();
        self.updateBadge();
      });
      return;
    }

    this.applyMetaFiltersOnly();
    this.updateBadge();
  };

  CiBrandCollectionFilters.prototype.buildMultiBrandGridDocument = function (brandItemLists) {
    var shell = this.gridContainer && this.gridContainer.querySelector('[data-ci-load-more-root]');
    var newShell = shell ? shell.cloneNode(true) : null;

    if (!newShell) {
      return null;
    }

    var list =
      newShell.querySelector('[data-brand-grid-list]') || newShell.querySelector('.ci-cbg__grid');
    var pagination = newShell.querySelector('[data-ci-load-more-pagination]');
    var noResults = newShell.querySelector('[data-brand-no-results]');

    if (pagination) pagination.remove();

    var existingEnd = newShell.querySelector('[data-ci-load-more-end]');
    if (existingEnd) existingEnd.remove();

    if (!list) return null;

    list.innerHTML = '';
    if (noResults) noResults.hidden = true;

    var seen = new Set();
    var fragment = document.createDocumentFragment();

    brandItemLists.forEach(function (items) {
      if (!items || !items.length) return;
      items.forEach(function (item) {
        var handle = (item.getAttribute('data-product-handle') || '').trim().toLowerCase();
        if (!handle || seen.has(handle)) return;
        seen.add(handle);
        var node = document.importNode(item, true);
        node.classList.remove('is-ci-load-more-hidden');
        node.removeAttribute('hidden');
        fragment.appendChild(node);
      });
    });

    list.appendChild(fragment);

    if (seen.size === 0) {
      if (noResults) noResults.hidden = false;
    }

    newShell.setAttribute('data-ci-search-results-count', String(seen.size));
    newShell.dataset.ciLoadMorePages = '1';
    newShell.dataset.ciLoadMorePage = '1';

    if (seen.size > 0) {
      var endEl = document.createElement('p');
      endEl.className = 'ci-load-more__end';
      endEl.setAttribute('data-ci-load-more-end', '');
      endEl.textContent = 'Has visto todos los productos';
      newShell.appendChild(endEl);
    }

    var virtualDoc = new DOMParser().parseFromString('<div id="ProductGridContainer"></div>', 'text/html');
    var container = virtualDoc.getElementById('ProductGridContainer');
    container.appendChild(newShell);

    return {
      doc: virtualDoc,
      count: seen.size,
    };
  };

  CiBrandCollectionFilters.prototype.fetchBrandProducts = function () {
    if (!this.isCatalog || !this.hasBrandFilter) {
      this.applyClientFilters();
      return;
    }

    var brands = this.getBrandSelection();
    var self = this;
    var fetchId = ++this.brandFetchId;

    if (!brands.length) {
      var sortParam = this.getSortParam();
      var params = sortParam ? 'sort_by=' + encodeURIComponent(sortParam) : '';
      this.renderPage(params);
      return;
    }

    this.saveBrandFilters();
    if (this.gridContainer) this.gridContainer.classList.add('is-loading');

    Promise.allSettled(
      brands.map(function (handle) {
        return self.fetchAllPagesForBrand(handle);
      })
    )
      .then(function (results) {
        if (fetchId !== self.brandFetchId) return;

        var brandItemLists = [];
        results.forEach(function (result) {
          if (result.status === 'fulfilled' && result.value && result.value.length) {
            brandItemLists.push(result.value);
          }
        });

        var merged = self.buildMultiBrandGridDocument(brandItemLists);
        if (!merged) return;

        var gridOptions = {
          singlePage: true,
          totalCount: merged.count,
          revealAll: true,
        };

        if (brands.length === 1) {
          gridOptions.fetchPath = '/collections/' + encodeURIComponent(brands[0]);
        }

        self.applyGridFromDocument(merged.doc, gridOptions);
      })
      .catch(function () {
        /* ignore */
      })
      .finally(function () {
        if (fetchId === self.brandFetchId && self.gridContainer) {
          self.gridContainer.classList.remove('is-loading');
        }
      });
  };

  CiBrandCollectionFilters.prototype.syncVisibility = function () {
    if (this.section.classList.contains('is-ci-remote-search')) {
      return;
    }

    var items = this.getItems();
    var visible = 0;

    items.forEach(function (item) {
      var hiddenBySearch = item.getAttribute('data-ci-search-hidden') === 'true';
      var hiddenByMeta = item.getAttribute('data-ci-meta-hidden') === 'true';
      var hiddenByBrand = item.getAttribute('data-ci-brand-hidden') === 'true';
      var hiddenByUnpublished = item.getAttribute('data-ci-unpublished-hidden') === 'true';
      var show = !hiddenBySearch && !hiddenByMeta && !hiddenByBrand && !hiddenByUnpublished;
      if (show) {
        item.removeAttribute('hidden');
        visible += 1;
      } else {
        item.setAttribute('hidden', '');
      }
    });

    var countValueEl = this.section.querySelector('[data-brand-count-value]');
    var countEl = this.section.querySelector('[data-brand-count]');
    var searchInput = this.section.querySelector('.ci-brand-collection-search');
    var hasSearch = searchInput && searchInput.value.trim().length > 0;
    var hasMeta = Object.keys(this.getMetaSelection()).length > 0;
    var brandSelection = this.getBrandSelection();
    var hasBrandClient = !this.isCatalog && brandSelection.length > 0;
    var hasCatalogBrands = this.isCatalog && brandSelection.length > 0;
    var hasClientFilter = hasSearch || hasMeta || hasBrandClient;

    if (countValueEl && countEl) {
      if (hasCatalogBrands && !hasSearch && !hasMeta) {
        countValueEl.textContent = String(visible);
        countEl.classList.add('is-filtered');
      } else {
        countValueEl.textContent = hasClientFilter
          ? visible
          : countValueEl.dataset.baseCount || countValueEl.textContent;
        countEl.classList.toggle('is-filtered', hasClientFilter);
      }
    }

    this.section.classList.toggle('is-search-empty', visible === 0);

    var loadMore = this.gridContainer && this.gridContainer._ciLoadMore ? this.gridContainer._ciLoadMore : null;
    if (loadMore) {
      if (hasClientFilter) {
        loadMore.setDisabled(true);
      } else if (hasCatalogBrands && brandSelection.length > 1) {
        loadMore.setDisabled(true);
      } else {
        loadMore.setDisabled(false);
        loadMore.reset();
      }
    }
  };

  CiBrandCollectionFilters.prototype.updateBadge = function () {
    var badge = this.section.querySelector('[data-ci-filter-badge]');
    if (!badge) return;

    var facetsRoot = this.queryPanel('#ci-facets-panel-content');
    var shopifyCount = facetsRoot ? parseInt(facetsRoot.dataset.ciActiveFilters || '0', 10) || 0 : 0;
    var metaCount = this.queryPanelAll('[data-ci-meta-filter]:checked').length;
    var brandCount = this.hasBrandFilter ? this.getBrandSelection().length : 0;
    var total = shopifyCount + metaCount + brandCount;

    badge.textContent = total;
    badge.hidden = total === 0;
  };

  CiBrandCollectionFilters.prototype.bindMetaFilters = function () {
    var self = this;
    this.queryPanelAll('[data-ci-meta-filter]').forEach(function (input) {
      if (input.dataset.ciMetaBound === 'true') return;
      input.dataset.ciMetaBound = 'true';
      input.addEventListener('change', function () {
        self.applyClientFilters();
      });
    });
  };

  CiBrandCollectionFilters.prototype.filterBrandList = function (query) {
    var q = (query || '').trim().toLowerCase();
    var visible = 0;

    this.queryPanelAll('[data-ci-brand-filter-item]').forEach(function (item) {
      var label = (item.getAttribute('data-ci-brand-filter-label') || '').toLowerCase();
      var match = !q || label.indexOf(q) !== -1;
      if (match) {
        item.removeAttribute('hidden');
        visible += 1;
      } else {
        item.setAttribute('hidden', '');
      }
    });

    var empty = this.queryPanel('[data-ci-brand-filter-empty]');
    if (empty) {
      empty.hidden = !q || visible > 0;
    }
  };

  CiBrandCollectionFilters.prototype.bindBrandFilters = function () {
    var self = this;
    var list = this.queryPanel('[data-ci-brand-filter-list]');
    this.hasBrandFilter = !!list;
    if (!list) return;

    this.queryPanelAll('[data-ci-brand-filter]').forEach(function (input) {
      if (input.dataset.ciBrandBound === 'true') return;
      input.dataset.ciBrandBound = 'true';
      input.addEventListener('change', function () {
        self.saveBrandFilters();
        self.updateBadge();
        if (self.isCatalog) {
          self.scheduleBrandFetch();
        } else {
          self.applyClientFilters();
        }
      });
    });

    var searchInput = this.queryPanel('[data-ci-brand-filter-search]');
    if (searchInput && searchInput.dataset.ciBrandSearchBound !== 'true') {
      searchInput.dataset.ciBrandSearchBound = 'true';
      searchInput.addEventListener('input', function () {
        self.filterBrandList(searchInput.value);
      });
      searchInput.addEventListener('search', function () {
        if (searchInput.value === '') self.filterBrandList('');
      });
    }
  };

  CiBrandCollectionFilters.prototype.createSearchParams = function (form) {
    var formData = new FormData(form || this.form);
    formData.delete('page');
    var params = new URLSearchParams();
    formData.forEach(function (value, key) {
      if (value == null) return;
      var trimmed = String(value).trim();
      if (trimmed === '') return;
      params.append(key, trimmed);
    });
    return params.toString();
  };

  CiBrandCollectionFilters.prototype.submitForm = function () {
    if (!this.form) return;
    var sortHidden = this.form.querySelector('[data-ci-facets-sort]');
    if (sortHidden && this.sortSelect) {
      sortHidden.value = this.sortSelect.value;
    }
    this.renderPage(this.createSearchParams());
  };

  CiBrandCollectionFilters.prototype.navigate = function (url) {
    if (!url) return;
    var parsed = new URL(url, window.location.origin);
    this.renderPage(parsed.searchParams.toString());
  };

  CiBrandCollectionFilters.prototype.renderPage = function (searchParams, updateURL) {
    var self = this;
    if (typeof updateURL === 'undefined') updateURL = true;
    if (searchParams === this.searchParamsPrev && updateURL) return;
    this.searchParamsPrev = searchParams;

    if (this.gridContainer) this.gridContainer.classList.add('is-loading');

    var url = window.location.pathname + '?section_id=' + encodeURIComponent(this.sectionId);
    if (searchParams) url += '&' + searchParams;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('ProductGridContainer');
        var newFacets = doc.getElementById('ci-facets-panel-content');
        var newCount = doc.querySelector('[data-brand-count]');

        if (newGrid && self.gridContainer) {
          self.gridContainer.innerHTML = newGrid.innerHTML;
        }

        if (newFacets && !self.isCatalog) {
          var currentFacets = self.queryPanel('#ci-facets-panel-content');
          if (currentFacets && currentFacets.parentNode) {
            currentFacets.replaceWith(newFacets);
          }
          self.form = self.panel ? self.panel.querySelector('#FacetFiltersForm') : null;
          self.rebindForm();
          self.bindMetaFilters();
          self.bindBrandFilters();
          self.restoreMetaFilters();
          self.restoreBrandFilters();
        }

        if (self.isCatalog && self.getBrandSelection().length > 0) {
          self.fetchBrandProducts();
        } else {
          if (newCount) {
            var countTarget = self.section.querySelector('[data-brand-count]');
            if (countTarget) {
              countTarget.innerHTML = newCount.innerHTML;
              var countValueElRestore = countTarget.querySelector('[data-brand-count-value]');
              if (countValueElRestore) {
                countValueElRestore.dataset.baseCount = countValueElRestore.textContent;
              }
            }
          }
          self.applyClientFilters();
          self.updateBadge();
        }

        self.filterUnpublishedCatalogProducts();

        if (updateURL) {
          var nextURL = window.location.pathname + (searchParams ? '?' + searchParams : '');
          window.history.pushState({ searchParams: searchParams }, '', nextURL);
        }

        if (self.gridContainer) self.gridContainer.classList.remove('is-loading');

        document.dispatchEvent(
          new CustomEvent('ci:collection-grid:updated', {
            detail: { section: self.section },
          })
        );
        document.dispatchEvent(
          new CustomEvent('ci:product-grid:updated', {
            detail: { root: self.gridContainer },
          })
        );
      })
      .catch(function () {
        if (self.gridContainer) self.gridContainer.classList.remove('is-loading');
      });
  };

  CiBrandCollectionFilters.prototype.rebindForm = function () {
    var self = this;
    this.form = this.panel ? this.panel.querySelector('#FacetFiltersForm') : null;
    if (!this.form || this.form.dataset.ciFacetBound === 'true') return;
    this.form.dataset.ciFacetBound = 'true';

    this.form.addEventListener('input', debounce(function (event) {
      if (event.target.matches('input[type="text"]')) return;
      self.submitForm();
    }, 400));

    this.form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="text"]')) return;
      self.submitForm();
    });

    this.form.querySelectorAll('input[type="text"]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.submitForm();
      });
    });

    this.form.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-ci-facet-remove]');
      if (!remove) return;
      event.preventDefault();
      self.navigate(remove.getAttribute('href'));
    });
  };

  function initSection(section) {
    if (!section || section.dataset.ciFiltersReady === 'true') return;
    if (!findDrawer(section)) return;
    section.dataset.ciFiltersReady = 'true';
    new CiBrandCollectionFilters(section);
  }

  document.querySelectorAll('[data-ci-brand-grid]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ci-brand-grid]') || event.target.closest('[data-ci-brand-grid]');
    if (section) {
      section.dataset.ciFiltersReady = 'false';
      initSection(section);
    }
  });
})();
